import type { NodeDimensions, Allocation } from './types';

export const defaultNodeDimensions: NodeDimensions = {
  nodeWidth: 1, nodeHeight: 1,
};

export const defaultAllocation: Allocation = {
  owningId: null,
  allocatedNodeId: null,
};
